module.exports = __webpack_public_path__ + "img/23 Animation 2-squashed.cc212aca.jpg";